export class Supplier {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly streetName: string|null,
    public readonly houseNumber: string|null,
    public readonly houseNumberAddition: string|null,
    public readonly postalCode: string|null,
    public readonly city: string|null,
    public readonly phone: string|null,
    public readonly email: string|null,
    public readonly vatRate: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): Supplier {
    return new Supplier(
      json['id'],
      json['name'],
      json['street_name'],
      json['house_number'],
      json['house_number_addition'],
      json['postal_code'],
      json['city'],
      json['phone'],
      json['email'],
      json['vat_rate'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}